module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3b",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('strong', [_c('em', [_vm._v("Chapter 2")]), _c('br'), _vm._v("Native American Sexuality in the Eyes of the Beholders, 1535–1710")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('a', {
    attrs: {
      "id": "ch02a"
    }
  }), _c('strong', [_c('em', [_vm._v("Gordon Sayre")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Early explorers’ accounts of the sexuality of Native American peoples are strongly influenced by the sexual overtones which imbued their perceptions of the continent as a whole. For sixteenth-century explorers the New World was charged with eroticism. Many engravings and paintings from the sixteenth through the eighteenth centuries portrayed a nude woman as an allegorical figure for the American continent. John Donne, in his well-known Elegy 19, uses America as a figure for the woman the poet is trying to undress, or “discover,” and seduce, even though the poem has, on a literal level, nothing to do with exploration or colonialism. The name “America” is itself the feminine form of the first name of explorer Amerigo Vespucci. A well-known engraving made around 1600 by Jan van der Straet shows Vespucci discovering America naked in her hammock."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not1"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not1"
    }
  }, [_vm._v("1")])]), _vm._v(" Many sixteenth-century explorers wrote narratives which dramatized their achievements as a sexual conquest of a virgin land, as in Sir Walter Ralegh’s description of Guiana as “a country that hath yet her maidenhead, never sacked, turned, nor wrought.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not2"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Therefore, representations of America and Native Americans written in the sixteenth and seventeenth centuries entered into a discourse that was highly eroticized. Even when explorers and missionaries tried to represent literally their eyewitness observations of native sexual or marriage customs, they were always responding to their own preconceptions, and frequently were writing of behavior in which they had been involved. The following analysis of accounts of indigenous Amerindian sexual practices will reveal how the position of the writer, as discoverer, missionary, furtrader "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("or colonial promoter, influenced the patterns of representations of sexuality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Giovanni da Verrazzano was the first European to explore the mid-Atlantic coast from the Carolinas north to Maine, in 1524. His brief report to King Francis I of France, who employed him to make the trip, presents a romantic, Arcadian image and can be read as a comedic tale of courtship between two eager partners, each anxious for signs of willingness in the other, but unable to communicate by speech and inclined to misinterpret the other’s gestures. Verrazzano found the natives of Narragansett Bay (presumably the same described by Roger Williams 120 years later) to be “the most beautiful and have the most civil customs that we have found on this voyage. They are taller than we are … and their manner is sweet and gentle, very like the manner of the ancients. … Their women are just as shapely and beautiful; very gracious, of attractive manner and pleasant appearance … they go nude except for a stag skin.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not3"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not3"
    }
  }, [_vm._v("3")])]), _vm._v(" Verrazzano also noted that they wore rich pelts, fancy hair arrangements, and jewelry of copper, which they valued more than gold. After detailing these ornaments, he added, “They are very generous and give away all they have.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not4"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not4"
    }
  }, [_vm._v("4")])]), _vm._v(" This image is not of a virgin land, innocently awaiting penetration by European men, but of a wealthy, comely, and civil partner who is generous and willing to please. It is more courtly than the more famous lines of the courtier, Ralegh. Three brief encounters in Verrazzano’s narrative sketch a courtship process that is also quite different from the John Smith/Pocahontas legend, which has been thoroughly mythologized and, more recently, analyzed."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not5"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not5"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the first episode, on North Carolina’s Outer Banks, Verrazzano sends a sailor swimming ashore with gifts of trinkets. The sailor tries to throw these onto the beach and return, but he is overcome by the surf and swept up on the beach. The natives “took him up by the head, the legs, and arms and carried him some distance away. Whereupon the youth, realizing he was being carried away like this, was seized with terror, and began to utter loud cries. … They took off his shirt and shoes and hose, leaving him naked, then made a huge fire next to him.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not6"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not6"
    }
  }, [_vm._v("6")])]), _vm._v(" Though both sides have good intentions, the scene conveys anxiety about captivity, rape, and cannibalism, for the observers on board the ship do not know will happen the youth, but believe that he will be roasted and eaten. Yet when he “showed them by signs that he wanted to return to the ship … with the greatest kindness, they accompanied him to the sea, holding him close and embracing him,”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not7"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not7"
    }
  }, [_vm._v("7")])]), _vm._v(" like a kind lover reassuring a reluctant virgin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("In a second episode soon after, Verrazzano’s men turn the tables. They meet an old woman who accepts their offer of food and a young woman with three children who angrily throws the food on the ground: “we wanted to take the young woman, who was very beautiful and tall, but it was impossible to take her because of the loud cries she uttered.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not8"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not8"
    }
  }, [_vm._v("8")])]), _vm._v(" They are forced to settle for one of her sons as a captive. The third episode comes after an exchange of commodities, and suggests that the natives have set limits to the kinds of trade they will enter into. During Verrazzano’s two-week stay, the Narragansetts every day “came to see us on the ship, bringing their womenfolk. They are very careful with them … and however many entreaties we made or offers of various gifts, we could not persuade them to let the women come on board ship.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not9"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not9"
    }
  }, [_vm._v("9")])]), _vm._v(" This Arcadia is full of enticing things, but its women are elusive. Verrazzano from the start sees North American women as attractive, but his efforts to court them are spurned, and each side reveals great anxiety about being captured by, or surrendering to, the other. And because we have only Verrazzano’s side of the story we cannot know for sure if the resistance of the young woman with the three children and the reticence of the “womenfolk” in general was customary or an impulsive reaction to alien aggression.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("This is the difficulty of studying Amerindian life in early contact and colonial times. For the social customs where archeology offers no evidence, for the outlook of tribes which barely survive today, we are dependent on accounts by Europeans who didn’t understand the cultures they described. These accounts are often laden with ethnocentrism, or project Europeans’ cultural obsessions onto the Amerindian Other, as we see in the courtly assumptions of Verrazzano or in the figures of the Wild Man, Noble Savage, and Natural Man."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not10"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not10"
    }
  }, [_vm._v("10")])]), _vm._v(" Nowhere is this more true than in descriptions of sexuality. Not because it was a taboo subject that explorers and colonists could not describe in frank or objective terms, but because nowhere, not even in war and trade, was the observer’s relationship to the behavior he described more fraught with semiconscious desires and fears. It’s easy to identify tropes referring to Arcadia or the Amazons, or phallocentrism as in Ralegh, but it is more difficult to determine what accurate ethnological information if any, lies behind the prejudices, and to do so one must take into account the particular position of each observer. Should an author’s portrayal of modest and chaste young virgins in Canada, for instance, be accepted as accurate, or attributed to his own "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("situation as a missionary sworn to chastity and the defense of the sacred vows of marriage? To his contempt for or envy of the colonists who solicit the attention of the local women? To his disgust with the licentious life of the upper classes in France? Examining accounts of northeastern North America from Verrazzano to 1710, one begins to see a fundamental contrast between the attitudes toward Indian sexuality characteristic of missionaries and those characteristic of explorers, traders, and colonial promoters. Missionaries grounded their representations in a need to maintain a separation between the Indians’ behavior and that of the Europeans, themselves included. Behavior which showed a primitive innocence had to be protected from the corrupting influences of the whisky and wealth acquired through trade. Alternatively, behavior they considered lewd and lascivious had to be reproved and corrected, or there was a risk it would infect colonists.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In contrast, explorers’ and promoters’ accounts of Indian marriage and sex treat it almost as another resource of the land. Instead of anxiety about maintaining separation, there is a promise of engagement and participation. Sometimes it takes the form of a metaphorical male conquest of the land itself, as in Raleigh’s portrayal of Guiana or Thomas Morton’s description of New Canaan (New England) as: “Like a faire virgin, longing to be sped,/And meete her lover in a Nuptiall bed,/Deck’d in rich ornaments t’advance her state.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not11"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not11"
    }
  }, [_vm._v("11")])]), _vm._v(" But sometimes it’s more of a romantic farce, as in Verrazzano, or a bawdy comedy, as we shall see in Lawson, and by 1700 there emerged inklings of a rationalized utopian system of sexuality, as in Lahontan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both groups of men relied upon hospitable receptions from the Indians, but each sought a different kind of hospitality. A Jesuit missionary might live in a "), _c('em', [_vm._v("cabane")]), _vm._v(" and welcome adoption into a native family, but he would never marry a native woman. Traders, on the other hand, often married natives, and wrote with jocular delight of their hosts’ custom of offering young women as bedfellows during their stay in a community. Virginia planter and promoter Robert Beverley leant an exotic seraglio atmosphere to this hospitality, this “remarkable way of entertaining Strangers of Condition.”")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("he is regal’d till Bed time; when a Brace of young Beautiful Virgins are chosen, to wait upon him that night, for his particular refreshment. These Damsels are to Undress this happy Gentleman, and as soon as he is in Bed, they gently lay themselves down by him, one on one side of him, and the "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v("other on the other. They esteem it a breach of Hospitality, not to submit to every thing he desires of them."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not12"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not12"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Although this treatment is reserved for “Men of great Distinction,” the American setting broke down the class strata of Europe and offered a commoner the chance to acquire such “Distinction” through a wealth of trade goods. The contrast between this eroticism and the missionary attitude can be seen in a comment from Gabriel Sagard, a Recollet missionary among the Huron, who wrote in 1632: “One of the chief and most annoying embarrassments they caused us at the beginning of our visit to their country was their continual importunity and requests to marry us, or at least to make a family alliance with us.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not13"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not13"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was ample evidence in native customs to support both the theory that Indians were lustful and promiscuous and the view that they were chaste and reserved. Jesuit Paul Lejeune’s "), _c('em', [_vm._v("Relation")]), _vm._v(" of 1639 described native courtship practices: “There is a most evil custom among the Savages. Those who seek a girl or a woman in marriage go to her to make love at night.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not14"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not14"
    }
  }, [_vm._v("14")])]), _vm._v(" Because the woman reportedly would extinguish a small fire as a signal that her suitor was welcome, the baron de Lahontan called this custom "), _c('em', [_vm._v("courir Vallumette,")]), _vm._v(" “running the match.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Common evidence of chastity, on the other hand, included the custom of a sexual probation period for newlyweds. Lafitau, LeClercq, and Deliette all wrote of a six-month to one-year delay in consummating a marriage, “to do themselves honor, for when they have children immediately at the end of nine months it is a matter of reproach when they quarrel to say that they loved their husbands before marrying them.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not15"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not15"
    }
  }, [_vm._v("15")])]), _vm._v(" A few texts reported on abortion techniques which could have ensured that newlyweds were childless. Missionaries, however, were generally more inclined to stress the chastity of the Indians, or at least of their converts, often as part of a melodrama of primitive innocence confronting the corruption of trade and rum. Thus, missionaries took the well-defined Christian separation between the chaste and the unchaste and used it as an analogy for the distinction between the converted and unconverted around their mission. Lejeune, who lived among the Huron in today’s Ontario in the 1630s, reported on the chastity of his converts: “I have heard on good authority that some shameless women, who had approached some men at night and solicited them to do evil in secret, received for answer, only these words: ’I believe in God, I pray to him every day; he forbids such actions, I cannot commit them.’”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not16"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not16"
    }
  }, [_vm._v("16")])]), _vm._v(" He added a parallel "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v("story about female converts who rejected the advances of unchaste men:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Three young Algonquins from the Island [Ottawa], having come down to Kebec, and wishing to make love according to their custom, addressed themselves to Christian girls. They were greatly astonished when these girls told them to apply to us about the matter, and that they would decide nothing without our advice. These good people came to us and asked us if we governed the Savage girls."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not17"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not17"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A later "), _c('em', [_vm._v("Relation")]), _vm._v(" tells of a Frenchman who “took the resolution to entice into sin as many Savages as he could, so as to ruin the country.... He cajoles some girls, and invites them to drink, on purpose to intoxicate them, in order to pass from one crime to another.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not18"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not18"
    }
  }, [_vm._v("18")])]), _vm._v(" But when he attempts to seduce a Christian Indian girl, she upbraids him so effectively that he vows to change his ways and work for the conversion of Indians. The Canadian Jesuits had little success at fully Frenchifying the Indians, but in vignettes such as these, they could use sexuality, or rather chastity, as a sign that the natives were a docile and regenerate people with moral concepts familiar to Europeans, and denounce the dissolute morals of unregenerate colonial traders. It’s hard to tell if the Hurons’ traditional customs encouraged the chastity which the converts maintained, or if it was a product of Christian ideology.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For traders, assimilation took a different meaning. John Lawson explained how it was for more than sensual reasons that traders sought out native partners:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("The English Traders are seldom without an Indian Female for his Bed-fellow, alledging these Reasons as sufficient to allow of such a Familiarity. First, they being remote from any white People, that it preserves their Friendship with the Heathens, they esteeming a white Man’s Child much above one of their getting, the Indian Mistress ever securing her white Friend Provisions whilst he stays amongst them. And lastly, This Correspondence makes them learn the Indian Tongue much the sooner."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not19"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not19"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This process quickly became almost routine. Most Indian nations were accustomed to strengthening alliances through intermarriage or sexual exchange. The French fur traders, or "), _c('em', [_vm._v("coureurs de bois,")]), _vm._v(" used this practice to their advantage, maintaining wives or lovers in one or more villages as a means of securing a steady supply of pelts."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not20"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not20"
    }
  }, [_vm._v("20")])]), _vm._v(" This was also common in the southern colonies, but forbidden in Puritan New England. William Byrd II, a wealthy Virginian with a cavalier jocularity even stronger than "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v("Lawson’s, extolled the advantages of intermarriage, describing the Indians as healthy and attractive, as Verrazzano had, and satirically contrasting religion with sex, the missionary’s with the trader’s style: “a sprightly Lover is the most prevailing Missionary that can be sent among these, or any other Infidels.” Byrd also recognized that “The French, for their Parts, have not been so Squeamish in Canada, who upon Trial find abundance of Attraction in the Indians. Their late Grand Monarch thought it not below even the Dignity of a Frenchman to become one flesh with this People, and therefore Ordered 100 livres for any of his Subjects, Man or Woman, that would intermarry with a Native.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not21"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not21"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Byrd believed that this gave the French colony, and Catholicism, an edge over the English. He was mostly accurate; in the earliest days of the colony, Québec founder Samuel de Champlain had encouraged marriages between French men and Christianized Indians. Officials had offered a grant of three thousand livres to any man who married a native woman."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not22"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not22"
    }
  }, [_vm._v("22")])]), _vm._v(" This offer was never taken up, however, for the Church would marry only Christian Indians such as the girls sent to Québec convents. But these girls often refused to assimilate, or refused to abandon the chastity so firmly inculcated by the nuns. The Jesuits soon withdrew their support for intermarriage, and starting in 1684 colonial policy prohibited it. The major reason was that the sexual liaisons of traders and explorers had had the effect of easing the transition of Frenchmen into Indian life and away from the colony, rather then solidifying the Frenchification of the Indians. A 1709 letter from a Jesuit in Canada reports that “the experience we have had in this country is that all the Frenchmen who have married Indian women have become libertines … and that the children they have had are as idle as the Indians themselves; one must withhold permission for these sorts of marriages.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not23"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not23"
    }
  }, [_vm._v("23")])]), _vm._v(" This judgment might be attributed to an antipathy between fur traders and missionaries, but at times the missionaries opposed not only fur traders’ relations with the Indians but even settlers’. Explorer Pierre-Esprit Radisson suspected that this was because missionaries were themselves profiting from the fur trade: “The fathers Jesuits not willing to permitt French families to goe there, for to conserve the best to their profitt, houlding this pretext that yong men should frequent the wild women, so that the Christian religion by evil example could not be established.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not24"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not24"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In stories told by John Lawson, the worst fears of missionaries seem to be borne out; the ethnographic account of native customs undisturbed by Europeans turns into a promotional tract offering sex for male colonists’ "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v("exploitation: “The Girls at 12 or 13 Years of Age, as soon as Nature prompts them, freely bestow their Maidenheads on some Youth about the same Age, continuing her Favours on whom she most affects, changing her Mate very often … Multiplicity of Gallants never being a Stain to a Female’s Reputation, or the least Hindrance of her Advancement, but the more Whorish, the more Honourable.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not25"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not25"
    }
  }, [_vm._v("25")])]), _vm._v(" The innocence of “Nature” and “freedom” in this passage quickly shifts to a language specific to European masculinist sexuality. By the next page, the innocence of these girls becomes an excitatory ploy:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("They set apart their youngest and prettiest Faces for trading Girls; these are remarkable by their Hair, having a particular Tonsure by which they are known, and distinguish’d from those engag’d to Husbands. They are mercenary, and whoever makes Use of them, first hires them, the greatest Share of the Gain going to the King’s Purse, who is the chief Bawd … and his own Cabin (very often) being the chiefest Brothel-House."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not26"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not26"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The later chapter “An Account of the Indians of North Carolina” repeats much of this, going into more detail about the customs behind this sex trade: “every one of the Girl’s Relations arguing the Advantage or Detriment that may ensue such a Night’s Encounter; all which is done with as much Steadiness and Reality, as if it was the greatest Concern in the World … making no Difference betwixt an Agreement of this Nature, and a Bargain of any other.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not27"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not27"
    }
  }, [_vm._v("27")])]), _vm._v(" Lawson also remarked that “The Trading Girls … have an Art to destroy the Conception, and she that brings a Child in this Station, is accounted a Fool.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not28"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not28"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lawson thus tears down the utopian isolation and innocence of Native American sexuality, the favorable image that prompted both to the lightly salacious charms in Verrazzano’s narrative and the moralizing of the missionaries, in order to set up a colonial trading house for sexual resources. Yet like many prurient scenes, his have a comic side as well. Lawson tells a story of “Our Fellow Traveller” on his thousand-mile trek through Carolina, who, making camp in an Indian village, and “having a great Mind for an Indian Lass, for his Bed-Fellow that Night, spoke to our Guide, who soon got a Couple, reserving one for himself.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not29"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not29"
    }
  }, [_vm._v("29")])]), _vm._v(" The system is presented as indigenous, a natural opportunity for lustful colonists. Lawson’s friend goes through a farcical marriage, what he calls a “Winchester-Wedding,” which seems contrived to amuse his English readers: “Everyone of the Bride-Maids were as great Whores, as Mrs. Bride.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not30"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not30"
    }
  }, [_vm._v("30")])]), _vm._v(" In the morning, however, Lawson finds that “Mr. Bridegroom, who in less "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v("than 12 Hours, was Batchelor, Husband, and Widdower”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not31"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not31"
    }
  }, [_vm._v("31")])]), _vm._v(" has been rolled, relieved of all his trading goods and even his shoes. The veracity of Lawson’s story is doubtful, but its objective truth is less the issue than the inappropriateness of the terms he uses. The whorehouse was alien to Native America, even if this particular trader did treat the women as whores, and was relieved of his goods.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lawson’s Indian bordello is just one trope used to twist representations of Indian sexuality into forms attractive to male European readers. Robert Beverley’s "), _c('em', [_vm._v("History and Present State of Virginia")]), _vm._v(" (1705) was a promotional piece similar in goals and form to Lawson’s (both Beverley and Lawson owned large tracts of land in their colony and stood to profit from immigration), yet Beverley chose to ennoble the Indians, to depict them as worthy company for tobacco planters with social pretensions. In the area of sexuality, this entailed the seraglio for “Strangers of Condition” quoted above, but Beverley insisted that this was not prostitution, “Tho the young Indian Women are said to prostitute their bodies for Wampom Peak, Runtees, Beads, and other such like fineries; yet I never could find any ground for the accusation, and believe it only to be an unjust scandal upon them.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not32"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not32"
    }
  }, [_vm._v("32")])]), _vm._v(" The origin of accounts such as Lawson’s, Beverley suggested, lay with the more vulgar male colonists, not with the girls whose sexual license was merely a “frolicksom” freedom in the disposition of their own bodies: “Indeed I believe this story to be an aspersion cast on those innocent Creatures, by reason of the freedom they take in Conversation, which uncharitable Christians interpret as Criminal, upon no other ground, than the guilt of their own Consciences.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not33"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not33"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Beverley was one of a few early eighteenth-century writers who approached an understanding of sexuality which went beyond what Michel Foucault has called the “repressive hypothesis,” a dynamic which imagines sexual freedom only as the transgression of restraint, and, conversely, social power as controlling sexuality through “prohibition, censorship, and denial.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not34"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not34"
    }
  }, [_vm._v("34")])]), _vm._v(" Most colonial writers recognized that repression would not exist in a prelapsarian society, nor in that of the Deists’ Natural Man. However, they couldn’t quite figure out any other way to think about sexual behavior. For example, if marriages among the Indians were not indissoluble, and divorce was not accompanied by any stigma, did this mean that virtually all marriages ended in divorce, or that so few did that there was no need to control it? Did an apparent libertinism imply a high rate of adultery? What was the cause of such promiscuity?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _vm._v("The accounts of Roger Williams, in his annotated dictionary of the Algonquian language, are symptomatic of the confusion on these issues. With regard to adultery, he gave the word “Mammaûsu. "), _c('em', [_vm._v("an adulterer”")]), _vm._v(" and described the punishment: “commonly, if the Woman be false, the offended Husband will be solemnly revenged upon the offendor, before many witnesses, by many blowes and wounds.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not35"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not35"
    }
  }, [_vm._v("35")])]), _vm._v(" Yet in the preceding chapter, “Of their Government and Justice,” he suggested that the moral purity of the Indians greatly exceeded the English, that “although thay have not so much to restraine them (both in respect of knowledge of God and Lawes of men) as the English have, yet a man shall never heare of such crimes amongst them of robberies, murthers, adulteries, &c, as amongst the English.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not36"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not36"
    }
  }, [_vm._v("36")])]), _vm._v(" If there was no adultery, how did he observe the punishment for it, and why would such a law be needed? Does the report of a harsh punishment for adultery contradict the claim that adultery was unheard of support it? The repressive hypothesis led to accounts of Indian behavior which seem scarcely credible in the context of European customs. For example, many colonial observers echoed Williams’s remark that promiscuity among the unmarried Indians was not inconsistent with later fidelity: “Single fornication they count no sin, but after Mariage … then they count it hainous for either of them to be false.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not37"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not37"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Since most European readers imagined the Indians to be “savages” living in a bestial anarchy without morals or restraints, colonial writers struggled to either affirm this view or to rebut it. However, the rebuttal sometimes consisted of a claim for an innocent absence of sin, at other times for a repression more effective than in Europe. The controversy over nakedness, modesty, and visual provocation was indicative of this conundrum. Williams’s chapter “Of their nakednesse and clothing” described how “their Female they, in a modest blush cover with a little Apron of an hand breadth from their very birth,” but that “Custome hath used their minds and bodies to it [nakedness], and in such a freedom from any wantonnesse, that I have never seen that wantonnesse amongst them, as, (with griefe) I have heard of in Europe.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not38"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not38"
    }
  }, [_vm._v("38")])]), _vm._v(" If seeing others naked was really so routine, one would not expect the women to show a “modest blush.” Marc Lescarbot, a French visitor to Acadia in the early seventeenth century, stated the problem more clearly, yet initiated a series of repetitions and corrections: “One might think that the nakedness of this people would make them more lecherous, but the contrary is the case. … I can say for our savages, that I never saw amongst them any immodest gesture or look, and I venture to affirm that they are far less given "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _vm._v("to that vice than we in these parts.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not39"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not39"
    }
  }, [_vm._v("39")])]), _vm._v(" He explained this not by familiarity with the sight of the naked body but by reference to medical theories that the Americans’ lack of salt, spices, meat, and even hats all suppressed the libido, as did the use of tobacco.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lescarbot was a lawyer who went to Acadia in 1606–7 as a guest of the colonial commander de Poutrincourt. During his short stay, he studied the customs of the Souriquoi Indians around Port Royal in today’s Nova Scotia. Gabriel Sagard, author of "), _c('em', [_vm._v("Le Grand voyage du pays des Hurons")]), _vm._v(" (“Long voyage to the country of the Hurons”), was a Recollet missionary and one of the first Frenchmen to live among the Hurons, along the south shore of Lake Huron, in 1623–24. These two men’s eyewitness accounts of the native customs of two separate tribes might, one hopes, offer accurate ethnological information. Yet instead, the two texts weave a maze of misplaced repression hypotheses, plagiarism, and contradictions whose motives we can only guess at. In describing the continence of the Indians, Lescarbot used an analogy to a barbaric people of ancient times, which, from Herodotus to Tacitus, often inspired the same tropes of primitivism as the American Indians did in the Renaissance: “Caesar praises the Germans for having in their ancient savage life such continence that they reputed it a thing most vile for a young man to have the company of a woman or girl before he reached the age of twenty.” Sagard began his chapter “Marriage and Concubinage” with the same allusion to the Germans, yet drew a contrast rather than a comparison: “It is the reverse with the boys and young men of Canada, and especially with those of the Huron country, who are at liberty to give themselves over to this wickedness as soon as they can, and the young girls to prostitute themselves as soon as they are capable of doing so. Nay even the parents are often procurers of their own daughters.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not40"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not40"
    }
  }, [_vm._v("40")])]), _vm._v(" Lescarbot, the lawyer and classicist, saw the Souriquoi as emblematic of a primitive innocence and absence of lust, such as prevailed among the ancient Germans, while Sagard, the missionary, saw in the Huron a sinful license for youthful sex, altogether unlike the mores of the Germans. One might assume that this contrast was due to the customs of different tribes or the prejudices of different observers, if there were not evidence that both writers were expressing preconceived notions. In the following lines Sagard again reverses his ground: “the parents are often procurers of their own daughters; although I can truthfully say that I have never seen a single kiss given, or any immodest gesture or look, and for this reason I venture to assert that they are less prone to this vice than people here.” These "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _vm._v("are almost the same lines as in Lescarbot! Sagard, like Lescarbot, claims that he saw no immodesty. He even offers the same reasons as Lescarbot: the absence of hats, spices, and wine, and the presence of tobacco (which was still a novelty in Europe). The authority of these exploration narratives was grounded on the eyewitness observations that few other Europeans could offer in the 1610s and 1620s. Yet can Sagard’s claim for what he saw or didn’t see be taken seriously if it is copied nearly verbatim from Lescarbot, who had seen a different tribe in a distant place? Although such plagiarism or repetitions are common in the colonial ethnographic sources on American Indian life, they are particularly instructive in regard to sexuality, because in sex, the truth, like desire itself, is so often believed to reside in what is hidden, although its promise is conveyed through a gaze upon a body.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s not simply that Sagard copied Lescarbot. Both responded to a third, earlier colonial ethnographer, Jean de Léry, whose "), _c('em', [_vm._v("History of a Voyage to the Land of Brazil")]), _vm._v(" (1578) included a detailed account of the customs of the Tupi people of the Rio de Janiero area. At a time when the geography of America was vague, the great cultural and geographic distance between Canada and Brazil was less significant to these writers than the chance to generalize about “les sauvages américains.” De Léry too praised the discretion of the natives, described harsh punishments for adultery, and the coexistence of premarital promiscuity with marital fidelity. His most precise echo of Sagard and Lescarbot, however, regards the so-called panders: “It is true that before they marry off their daughters, the fathers and relatives have no great scruples about prostituting them to the first comer.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not41"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not41"
    }
  }, [_vm._v("41")])]), _vm._v(" I don’t believe that this observation can be rejected simply because it appears to be plagiarized. Lescarbot does cite de Léry (“Jean de Léry praises the Brazilians for this continence”)"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not42"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not42"
    }
  }, [_vm._v("42")])]), _vm._v(" and therefore refers to him obliquely also in this passage: “The maidens of Brazil have the same liberty of Canada to prostitute themselves as soon as they are able. Indeed the fathers act as their pandars, and think it an honour to give them to the men of these parts, in order to have children of their blood.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not43"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not43"
    }
  }, [_vm._v("43")])]), _vm._v(" The issue might be clarified by separating what the three writers may have seen from the conclusions they drew. The “liberty” of the “maidens” corresponds to the freedom and agency attributed to native girls by many other observers, including Lahontan (see below). Sagard’s version, by first claiming that the girls “prostitute” themselves, then shifting the agency to the fathers/panders, suggests that he may have assumed a patriarchal prerogative controlling "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _vm._v("the girls’ behavior, where in fact there was none. Moreover, both Lescarbot and de Léry specify that the fathers acted as panders to the French colonists (de Léry added, “the Norman interpreters had already, before our arrival, taken advantage of them in several villages”)."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not44"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not44"
    }
  }, [_vm._v("44")])]), _vm._v(" Significantly, it is the secular colonist, Lescarbot, who describes the involvement of the French in the natives’ behavior, adding: “But to consent to this would be a thing unworthy of a Christian, and we see, to our great hurt, that God has severely punished this vice by the pox.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not45"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not45"
    }
  }, [_vm._v("45")])]), _vm._v(" The pox was syphilis, thought to have been brought to Europe from America by the Spaniards. In his account, the Indians’ sexual freedom, or rather the sexual hospitality which the colonists enjoyed and confused with a natural libertinism, is less a feature of their own culture than a temptation and a lesson to colonists. Such moral lessons were also drawn by missionary writers, but with the important difference that missionaries were not likely to include the involvement of Europeans (the succumbing to temptation) as part of the lesson. Sagard describes the wickedness of the girls prostituting themselves at the beginning of his chapter on “Marriage and Concubinage,” and then tells in euphemistic language of the importunity of the girls toward him and his brother Recollects at the very end of the chapter, as if he feared the reader might connect the two and suspect that the missionaries consorted with the girls.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The opposing attitudes of the missionaries and the traders toward sex with and among the Indians frustrates efforts to understand what native sexuality was really like. Missionaries saw only innocence and corruption and anxiously tried to separate the two, while traders and promoters described sexual customs as if made for their own use and abuse. One French writer, however, offers a third position on native sexuality, an eagerness to engage, not in penetration, but in a comparison and philosophical examination of sexual customs in European and American Indian societies. This is the baron de Lahontan, a cultural and literary innovator in colonial writing. His "), _c('em', [_vm._v("Nouveaux Voyages dans l’Amérique septentrionale")]), _vm._v(" does more than merely narrate his experience or describe his observations, and therefore he needs to be read rhetorically, not literally.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the third volume of his 1703 work, Lahontan wrote a dialogue between “Adario,” a Huron Indian who has been to France, and “Lahontan,” and used the native’s voice to express radical ideas that the author had learned from living among the Indians. “Adario” describes Huron sexuality, law, and medicine in a manner which antipates Diderot and the "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _vm._v("French Enlightment, while the “Lahontan” character defends Catholicism and the colonial policies which the author had by that time rejected.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By contrasting and comparing colonial and native societies, Lahontan begins to transcend the repressive hypothesis; he calls into question the common Enlightenment opposition between reason and passion, noting that the Indians “are altogether Strangers to that Blind Fury which we call Love”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not46"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not46"
    }
  }, [_vm._v("46")])]), _vm._v(" and implying that reason is a natural faculty and passion a product of society. In the empiricist thinking of the Enlightenment, from Locke to Condillac and LaMettrie, sex was offered as proof of the causal relationship between sensory stimuli and physical responses. “What Man in the World can hear the Amorous Intrigues of the confessing Ladies, without being Transported, especially if he be one of those who injoy Health, Youth, and Strength?”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not47"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not47"
    }
  }, [_vm._v("47")])]), _vm._v(" asks Adario of the priests. Since the Indians apparently do not have the same hard-wired patterns of stimulus and response, they are immune from the embarrassing inconsistencies of biology and morality that plague Europeans, such as the contradiction between the Jesuit vows of chastity and the natural imperative of reproduction. Adario goes on to accuse the priests of cavorting with young girls, of using the withdrawal method of contraception, and of lacking the power of resistance which, he claims, is natural to the Indians.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lahontan also reversed the Western pattern of the male as aggressor in sexual relations. We’ve seen that many writers observed a high degree of sexual liberty among Indian girls before marriage. Sagard even included an account of a healing ritual, whereby in accordance with a sick woman’s dream, “all the girls in a town” assemble by the patient and “are all asked, one after another, which of the young men of the town they would like to sleep with them.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not48"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not48"
    }
  }, [_vm._v("48")])]), _vm._v(" The chosen boys are notified, and the next night all the couples have sex in the presence of the ill woman. Lahontan transforms this provocative idea of female sexual initiative by theorizing it within a rationalized system of sexuality that contrasts with European mores. In his earlier ethnographic “Account of the Amours and Marriages of the Savages,” Lahontan wrote that “the Men are as cold and indifferent as the Girls are passionate and warm. The former love nothing but War and Hunting, and their utmost ambition reaches no farther.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not49"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not49"
    }
  }, [_vm._v("49")])]), _vm._v(" This leads to an eroticization of the Indian woman, and a corresponding promise of potency and penetration for the male colonist: “The Savage Women like the French better than their own Countrymen, by reason that the former are more prodigal of their Vigour, and mind a Woman’s Business more closely.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not50"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not50"
    }
  }, [_vm._v("50")])]), _vm._v(" In the "), _c('em', [_vm._v("Dialogues,")]), _vm._v(" Lahontan develops "), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _vm._v("this point beyond a merely sensualist male fantasy, showing that such fantasies are as much about the male’s loss of sexual control as they are about gaining control over females. The consequence of the “nakednesse” of the Indians upon modesty and excitability was addressed by Lescarbot, Williams, and others, as we’ve seen. Rather than consider the automatic physical response which such an unobstructed gaze would provoke, Lahontan reverses the question, considering the power of the female gaze over the male member: “the young Women taking a view of the Naked parts, make their choice by the Eye…. Some love a well shaped Man let a certain matter about him be never so little. Others make choice of an ill shap’d sorry like Fellow, by reason of the goodly size of I know not what.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not51"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not51"
    }
  }, [_vm._v("51")])]), _vm._v(" Adario’s fantasy of female choice leads to a critique of the double standards of European sexual mores: “You Christians have another impertinent Custom. … Your Men glory in the Debauching of Women, as if yielding to the Temptations of Love were not equally Criminal in either Sex____Every body Censures the Lady, and cries up the Cavalier, whereas the former merits a Pardon, and the latter deserves to be Punish’d.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not52"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not52"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sexual and the political are entwined in Lahontan’s text as in the feminism of the late 1960s: “A Young Woman, say they, is Master of her own Body, and by her Natural Right of Liberty is free to do what she pleases.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not53"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not53"
    }
  }, [_vm._v("53")])]), _vm._v(" Adario provides a concrete instance of this when he speaks of his daughter, who has come to the interview with “Lahontan” and is about to marry a man her father disapproves of. Adario reminds us that he cannot prevent this liaison, because she would say to him, “What do you think Father! Am I your Slave? Shall I not enjoy my Liberty?”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not54"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not54"
    }
  }, [_vm._v("54")])]), _vm._v(" The sexual freedom of the Indians in Lahontan is imbued with revolutionary and rational demands for freedom from restraint and for the natural power of reason over social custom. The Indians’ practice of divorce and of marriage by contract for thirty years leads to an indictment of Europe: “they lay down this for a firm and unmovable truth, that we Europeans are born in Slavery.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not55"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not55"
    }
  }, [_vm._v("55")])]), _vm._v(" Finally, when Adario invites the “Lahontan” character to repeat the transformation which Lahontan the author had in fact already accomplished, that is, to “turn Huron,” Adario buttresses the invitation with the comment, “I am Master of my own Body.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not56"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not56"
    }
  }, [_vm._v("56")])]), _vm._v(" Thus the Indian is feminized, yet the feminine becomes the position of reason and freedom of choice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lahontan’s radical, utopian parable climaxes the story of how colonial writers’ representations of Native American sexuality reflected their own "), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _vm._v("positions and interests. Lahontan was perhaps the first to manipulate the material self-consciously, to be aware that the argument he was making had less to do with the innocence or corruption of Indian sexuality than it did with his own critique of European sexuality. Yet Lahontan is the beginning of another narrative, that of modern speculations about what is “natural” sexual behavior. Margaret Mead’s "), _c('em', [_vm._v("Coming of Age in Samoa")]), _vm._v(" created a stir in 1950s America by presenting a favorable portrait of a society where sexual freedom and experimentation was encouraged among young people, where the impulses of hormones did not have to battle against social and moral restraints. George Devereux proposed a similar reading of the customs of an American Indian tribe, based on fieldwork done among the Mohave in the 1930s. Devereux wrote that “Mohave sex-life is entirely untrammeled by social restraint” and that children enjoyed sexual relations without adult reprisal. Most significant were Devereux’s observations that “there is little or no objection to homosexuality among the Mohave.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not57"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not57"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sexual appetite of adolescents is no longer noteworthy in our society, but arguments about the naturalness of homosexuality are, and therefore it should be no surprise that recent scholarship on Native American sexuality has emphasized homosexuality. Many articles have addressed the phenomenon of the "), _c('em', [_vm._v("berdache,")]), _vm._v(" the term French seventeenth-century explorers applied to Indian men who adopted the clothing and social roles of women. The Jesuit Jacques Marquette, first European to explore the upper Mississippi valley, wrote,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("I know not through what superstition some Illinois, as well as some Nadouessi [Sioux], while still young, assume the garb of women, and retain it throughout their lives. There is some mystery in this, for they never marry and glory in demeaning themselves to do everything the women do. They go to war, however, but can use only clubs, and not bows and arrows … they pass for Manitous."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not58"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not58"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Brief accounts of berdaches appear in many early explorers’ writings, with varying degrees of homophobic scorn. Marquette’s comment that “they pass for Manitous,” spirits or signs of natural power, is significant for Walter L. Williams, whose "), _c('em', [_vm._v("The Spirit and the Flesh")]), _vm._v(" (1986) collects the observations of early colonists and combines them with his own fieldwork to propose a theory of the berdaches as spiritually inspired. By taking on women’s roles, berdaches were not demeaning themselves, because women and women’s work were not seen as inferior to men’s. If "), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _vm._v("berdaches’ gender identity did not correspond with their physical sex, it was because they had received special spiritual messages. Williams emphasizes that berdache is not the same as gay identity, and that many Indian men engage in sex with other men or with berdaches, but do not become berdaches. He concludes that the berdache phenomenon is not a sexual behavior but a cross-gender identity inspired by spiritual impulses. Most recently, Jonathan Goldberg’s "), _c('em', [_vm._v("Sodometries")]), _vm._v(" has entered the debate over Native American homosexuality by launching charges that Williams falls into ethnocentrism and “ homogenize [s] all natives into the figure of the Indian,” and that others who study the berdaches are insufficiently sensitive to contemporary gays or uncomprehending of Indian homosexuality."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch02not59"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ich02not59"
    }
  }, [_vm._v("59")])]), _vm._v(" As with the treatment of prostitution by Sagard and Lescarbot, Goldberg and Williams take the observations of earlier ethnographers and use them to support very different conclusions, revealing as much about their own positions as gay scholars as they do about the cultures they purport to describe. Because sexual identity is so culturally determined and determining, the berdaches are virtually impossible to understand or represent in any neutral or objective way. Native American sexuality continues to be seen through a lens which reflects the eye of the beholder.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NOTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not1"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not1"
    }
  }, [_vm._v("1")]), _vm._v(". Two leading critics of colonial American literature have published provocative interpretations of van der Straet’s engraving: see José Rabasa, "), _c('em', [_vm._v("Inventing America: Spanish Historiography and the Formation of Eurocentrism")]), _vm._v(" (Norman: University of Oklahoma Press, 1993), 27; and Peter Hulme, “Polytropic Man: Tropes of Sexuality and Mobility in Early Colonial Discourse,” in "), _c('em', [_vm._v("Europe and Its Others: Proceedings of the Essex Conference on the Sociology of Literature")]), _vm._v(" (Essex: Essex University Press, 1984), ed. Francis Barker et al., 17–18. The hammock is an invention of the Arawak natives of the Caribbean, and the word was adopted from their language.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not2"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not2"
    }
  }, [_vm._v("2")]), _vm._v(". Sir Walter Ralegh, "), _c('em', [_vm._v("Selected Writings,")]), _vm._v(" ed. Gerald Hammond (Harmondsworth, England: Penguin, 1986), 120. A fine study of this trope in the exploration and conquest of America-as-woman is Annette Kolodny, "), _c('em', [_vm._v("The Lay of the Land: Metaphor as Experience and History in American Life and Letters")]), _vm._v(" (Chapel Hill: University of North Carolina Press, 1975).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not3"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not3"
    }
  }, [_vm._v("3")]), _vm._v(". Lawrence C. Wroth, ed., "), _c('em', [_vm._v("The Voyages of Giovanni da Verrazzano")]), _vm._v(" (New Haven: Yale University Press, 1970), 138.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not4"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not4"
    }
  }, [_vm._v("4")]), _vm._v(". Ibid., 138.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _c('a', {
    attrs: {
      "id": "ich02not5"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not5"
    }
  }, [_vm._v("5")]), _vm._v(". See Kolodny, "), _c('em', [_vm._v("The Lay of the Land,")]), _vm._v(" 5; Hulme, “Polytropic Man,” 19–27; and Jeffrey Knapp, "), _c('em', [_vm._v("An Empire Nowhere: England, America, and Literature from")]), _vm._v(" Utopia "), _c('em', [_vm._v("to")]), _vm._v(" The Tempest (Berkeley: University of California Press, 1992), 210–18.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not6"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not6"
    }
  }, [_vm._v("6")]), _vm._v(". Wroth, "), _c('em', [_vm._v("The Voyages of Giovanni da Verrazzano,")]), _vm._v(" 135.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not7"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not7"
    }
  }, [_vm._v("7")]), _vm._v(". Ibid., 135.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not8"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not8"
    }
  }, [_vm._v("8")]), _vm._v(". Ibid., 136.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not9"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not9"
    }
  }, [_vm._v("9")]), _vm._v(". Ibid., 138.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not10"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not10"
    }
  }, [_vm._v("10")]), _vm._v(". A great number of scholarly studies could be listed here. Among the best are Olive Patricia Dickinson, "), _c('em', [_vm._v("The Myth of the Savage and the Beginnings of French Colonialism in the Americas")]), _vm._v(" (Edmonton: University of Alberta Press, 1984); Edward Dudley and Maximilian Novak, eds., "), _c('em', [_vm._v("The Wild Man Within: An Image in Western Thought from Renaissance to Romanticism")]), _vm._v(" (Pittsburgh: University of Pittsburgh Press, 1973); Hoxie Fairchild, "), _c('em', [_vm._v("The Noble Savage: A Study in Romantic Naturalism")]), _vm._v(" (New York: Russell and Russell, 1961).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not11"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not11"
    }
  }, [_vm._v("11")]), _vm._v(". Thomas Morton, "), _c('em', [_vm._v("New English Canaan")]), _vm._v(" (New York: Arno Press, 1972), 10.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not12"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not12"
    }
  }, [_vm._v("12")]), _vm._v(". Robert Beverley, "), _c('em', [_vm._v("The History and Present State of Virginia")]), _vm._v(" (Chapel Hill: University of North Carolina Press, 1947), 188–89.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not13"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not13"
    }
  }, [_vm._v("13")]), _vm._v(". Gabriel Sagard, "), _c('em', [_vm._v("The Long journey to the Country of the Hurons,")]), _vm._v(" trans. H. H. Langton (Toronto: Champlain Society, 1939), 125.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not14"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not14"
    }
  }, [_vm._v("14")]), _vm._v(". Reuben G. Thwaites, ed., "), _c('em', [_vm._v("The Jesuit Relations and Allied Documents,")]), _vm._v(" 73 vols. (Cleveland: Burrows Bros., 1896–1901), 16: 63.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not15"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not15"
    }
  }, [_vm._v("15")]), _vm._v(". Quotation from Pierre Deliette, “Memoir of De Gannes Concerning the Illinois Country,” in "), _c('em', [_vm._v("The Western Country in the 17th Century")]), _vm._v(" ed., Milo M. Quaife (Chicago: Lakeside Press, 1947), 116–17. See also Chrestien LeClercq, "), _c('em', [_vm._v("New Relation of Gaspesia with the Customs and Religion of the Gaspesian Indians,")]), _vm._v(" trans. William F. Ganong (Toronto: Champlain Society, 1910), 259; Joseph-François Lafitau, "), _c('em', [_vm._v("Moeurs des sauvages américains comparées aux moeurs des premiers temps")]), _vm._v(" (Paris: Maspero/La Découverte, 1983), 156–57.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not16"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not16"
    }
  }, [_vm._v("16")]), _vm._v(". Thwaites, "), _c('em', [_vm._v("Jesuit Relations,")]), _vm._v(" 16:61.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not17"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not17"
    }
  }, [_vm._v("17")]), _vm._v(". Ibid., 16:63")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not18"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not18"
    }
  }, [_vm._v("18")]), _vm._v(". Ibid., 29:185.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not19"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not19"
    }
  }, [_vm._v("19")]), _vm._v(". John Lawson, "), _c('em', [_vm._v("A New Voyage to Carolina, containing the exact description and Natural History of that Country, together with the present state thereof and a Journal of a Thousand Miles Travel’d thro; several Nations of Indians, Giving a particular Account of their Customs, Manners, etc.")]), _vm._v(" (London, 1709; reprint Chapel Hill: University of North Carolina Press, 1967), 35–36.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not20"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not20"
    }
  }, [_vm._v("20")]), _vm._v(". French historian Philippe Jacquin has described the blending of native custom and colonial desire: “The European saw the Indian as a seductress, fanatic with desire, a dream which fascinated the colonists and pushed them toward Indian society; a dream which became reality through the willingness of the Indians not only to allow their women to couple with the newcomers, but to encourage "), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _vm._v("these liaisons. In fact, the Indians could not imagine commercial or political relations without the exchange of women, without proposing a young woman for the stranger.” "), _c('em', [_vm._v("Les indiens blancs: Français et indiens en Amérique du nord, XVIiéme-XVIIIième Siècle")]), _vm._v(" (Paris: Payot, 1987), 190; my translation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not21"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not21"
    }
  }, [_vm._v("21")]), _vm._v(". William Byrd, "), _c('em', [_vm._v("Histories of the Dividing Line betwixt Virginia and North Carolina")]), _vm._v(" (New York, Dover, 1967), 4.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not22"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not22"
    }
  }, [_vm._v("22")]), _vm._v(". See Jacquin, "), _c('em', [_vm._v("Les Indiens Blancs,")]), _vm._v(" 192.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not23"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not23"
    }
  }, [_vm._v("23")]), _vm._v(". Ibid., 193; my translation. Quoted by Jacquin from document C11a in the French Archives de la Marine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not24"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not24"
    }
  }, [_vm._v("24")]), _vm._v(". Pierre-Esprit Radisson, "), _c('em', [_vm._v("Voyages of Peter Esprit Radisson, being an account of his Travels and Experience among the North American Indians from 1652 to 1684,")]), _vm._v(" ed. Gideon Scull (New York: P. Smith, 1943), 93.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not25"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not25"
    }
  }, [_vm._v("25")]), _vm._v(". Lawson, "), _c('em', [_vm._v("A New Voyage to Carolina,")]), _vm._v(" 40.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not26"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not26"
    }
  }, [_vm._v("26")]), _vm._v(". Ibid., 41.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not27"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not27"
    }
  }, [_vm._v("27")]), _vm._v(". Ibid., 190.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not28"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not28"
    }
  }, [_vm._v("28")]), _vm._v(". Ibid., 194.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not29"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not29"
    }
  }, [_vm._v("29")]), _vm._v(". Ibid., 46.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not30"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not30"
    }
  }, [_vm._v("30")]), _vm._v(". Ibid., 47.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not31"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not31"
    }
  }, [_vm._v("31")]), _vm._v(". Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not32"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not32"
    }
  }, [_vm._v("32")]), _vm._v(". Beverley, "), _c('em', [_vm._v("History and Present State of Virginia,")]), _vm._v(" 170.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not33"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not33"
    }
  }, [_vm._v("33")]), _vm._v(". Ibid., 171.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not34"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not34"
    }
  }, [_vm._v("34")]), _vm._v(". Michel Foucault, "), _c('em', [_vm._v("The History of Sexuality: An Introduction,")]), _vm._v(" trans. Robert Hurley (New York: Vintage Books, 1990), 10.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not35"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not35"
    }
  }, [_vm._v("35")]), _vm._v(". Roger Williams, "), _c('em', [_vm._v("A Key into the Language of America,")]), _vm._v(" ed. John J. Teunissen and Evelyn J. Hinz (Detroit: Wayne State University Press, 1973), 205.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not36"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not36"
    }
  }, [_vm._v("36")]), _vm._v(". Ibid., 203.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not37"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not37"
    }
  }, [_vm._v("37")]), _vm._v(". Ibid., 205.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not38"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not38"
    }
  }, [_vm._v("38")]), _vm._v(". Ibid., 185.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not39"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not39"
    }
  }, [_vm._v("39")]), _vm._v(". Marc Lescarbot, "), _c('em', [_vm._v("The History of New France,")]), _vm._v(" 3 vols., trans. W. L. Grant (Toronto: Champlain Society, 1907–14.), 3:163.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not40"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not40"
    }
  }, [_vm._v("40")]), _vm._v(". Gabriel Sagard-Theodat, "), _c('em', [_vm._v("The Long journey to the Country of the Hurons,")]), _vm._v(" ed. George M. Wrong, trans. H. H. Langton (Toronto: Champlain Society, 1939), 121.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not41"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not41"
    }
  }, [_vm._v("41")]), _vm._v(". Jean de Léry, "), _c('em', [_vm._v("History of a Voyage to the Land of Brazil,")]), _vm._v(" trans. Janet Whateley (Berkeley: University of California Press, 1990), 153.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not42"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not42"
    }
  }, [_vm._v("42")]), _vm._v(". Lescarbot, "), _c('em', [_vm._v("The History of New France,")]), _vm._v(" 3:164.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not43"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not43"
    }
  }, [_vm._v("43")]), _vm._v(". Ibid., 3:163.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not44"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not44"
    }
  }, [_vm._v("44")]), _vm._v(". de Léry, "), _c('em', [_vm._v("History of a Voyage to the Land of Brazil,")]), _vm._v(" 153.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not45"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not45"
    }
  }, [_vm._v("45")]), _vm._v(". Lescarbot, "), _c('em', [_vm._v("The History of New France,")]), _vm._v(" 3:163.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not46"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not46"
    }
  }, [_vm._v("46")]), _vm._v(". Louis Armand de lorn d’Arce, baron de Lahontan, "), _c('em', [_vm._v("New Voyages to North America,")]), _vm._v(" ed. Reuben Gold Thwaites (Chicago: A. C. McClurg, 1905), 452.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not47"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not47"
    }
  }, [_vm._v("47")]), _vm._v(". Ibid., 544.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _c('a', {
    attrs: {
      "id": "ich02not48"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not48"
    }
  }, [_vm._v("48.")]), _vm._v(" Sagard-Theodat, "), _c('em', [_vm._v("Long Journey to the Country of the Hurons,")]), _vm._v(" 120.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not49"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not49"
    }
  }, [_vm._v("49")]), _vm._v(". Lahontan, "), _c('em', [_vm._v("New Voyages to North America,")]), _vm._v(" 451.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not50"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not50"
    }
  }, [_vm._v("50")]), _vm._v(". Ibid., 455.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not51"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not51"
    }
  }, [_vm._v("51")]), _vm._v(". Ibid., 609.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not52"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not52"
    }
  }, [_vm._v("52")]), _vm._v(". Ibid., 610–11.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not53"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not53"
    }
  }, [_vm._v("53")]), _vm._v(". Ibid., 453.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not54"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not54"
    }
  }, [_vm._v("54")]), _vm._v(". Ibid., 605.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not55"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not55"
    }
  }, [_vm._v("55")]), _vm._v(". Ibid., 456.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not56"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not56"
    }
  }, [_vm._v("56")]), _vm._v(". Ibid., 554.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not57"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not57"
    }
  }, [_vm._v("57")]), _vm._v(". George Devereux, “Institutional Homosexuality of the Mohave Indians,” "), _c('em', [_vm._v("Human Biology")]), _vm._v(" 9 (1937): 518, 498–99.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not58"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not58"
    }
  }, [_vm._v("58")]), _vm._v(". Thwaites, "), _c('em', [_vm._v("Jesuit Relations,")]), _vm._v(" 59:129.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich02not59"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02not59"
    }
  }, [_vm._v("59")]), _vm._v(". Jonathan Goldberg, "), _c('em', [_vm._v("Sodometries: Renaissance Texts, Modern Sexualities")]), _vm._v(" (Stanford, Calif.: Stanford University Press, 1992), 189–92. Goldberg criticizes Ramon Gutierrez, "), _c('em', [_vm._v("When Jesus Came, the Corn Mothers Went Away")]), _vm._v(" (Stanford, Calif.: Stanford University Press, 1991); Harriet Whitehead, “The Bow and the Burden Strap,” in "), _c('em', [_vm._v("Sexual Meanings,")]), _vm._v(" ed. Sherry B. Ortner and Harriet Whitehead (Cambridge: Cambridge University Press, 1981), 80–115; Pierre Clastres, "), _c('em', [_vm._v("Society against the State,")]), _vm._v(" trans. Robert Hurley and Abe Stein (New York: Zone, 1987); and Devereux’s article cited above.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f5415ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 87
// module chunks = 0